import { useEffect } from 'react';

/**
 * steps back to the last real page when the current one came back empty because
 * rows disappeared between loads. keeps an out-of-range page from looking broken.
 * @param page - current 1-indexed page
 * @param totalPages - total pages reported by the api
 * @param itemCount - rows received for the current page
 * @param onPageChange - called with the page to fall back to
 */
export default function useClampPageToRange({
  page,
  totalPages,
  itemCount,
  onPageChange
}) {
  useEffect(() => {
    if (page <= 1 || itemCount > 0) return;
    if (totalPages > 0 && page > totalPages) onPageChange(totalPages);
  }, [page, totalPages, itemCount, onPageChange]);
}
